import { render, staticRenderFns } from "./increaseWaybill.vue?vue&type=template&id=764074c8&scoped=true&"
import script from "./increaseWaybill.vue?vue&type=script&lang=js&"
export * from "./increaseWaybill.vue?vue&type=script&lang=js&"
import style0 from "./increaseWaybill.vue?vue&type=style&index=0&id=764074c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764074c8",
  null
  
)

export default component.exports